const C = {
  name: "BottleBeer",
  dimensions: { width: 16, height: 41 },
  content: `
    <g clip-path="url(#clip0_12_1653)">
    <path d="M11.5 10.533V5.03296V1.03296C11.5 0.482959 11.05 0.032959 10.5 0.032959H5.5C4.95 0.032959 4.5 0.482959 4.5 1.03296V5.03296V10.533C1.99 12.493 0.5 15.533 0.5 18.723V39.033C0.5 39.583 0.95 40.033 1.5 40.033H14.5C15.05 40.033 15.5 39.583 15.5 39.033V31.033V20.033V18.723C15.5 15.543 14.01 12.493 11.5 10.533ZM13.5 23.033H9.5C8.95 23.033 8.5 23.483 8.5 24.033C8.5 24.583 8.95 25.033 9.5 25.033H13.5V26.033H11.5C10.95 26.033 10.5 26.483 10.5 27.033C10.5 27.583 10.95 28.033 11.5 28.033H13.5V30.033H7.5C6.95 30.033 6.5 29.583 6.5 29.033V21.033H12.5C13.05 21.033 13.5 21.483 13.5 22.033V23.033ZM6.5 2.03296H8.5C9.05 2.03296 9.5 2.48296 9.5 3.03296V4.03296H7.5C6.95 4.03296 6.5 3.58296 6.5 3.03296V2.03296ZM2.5 37.033V18.863C2.5 16.213 3.58 13.533 5.78 12.063C6.23 11.773 6.5 11.263 6.5 10.723V6.03296H8.5C9.05 6.03296 9.5 6.48296 9.5 7.03296V10.723C9.5 11.213 9.71 11.693 10.1 11.983C12.23 13.553 13.5 16.083 13.5 18.723V19.033H5.5C4.95 19.033 4.5 19.483 4.5 20.033V31.033C4.5 31.583 4.95 32.033 5.5 32.033H13.5V38.033H3.5C2.95 38.033 2.5 37.583 2.5 37.033Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1653">
    <rect width="15" height="40" fill="currentColor" transform="translate(0.5 0.032959)"/>
    </clipPath>
    </defs>
  `
};
export {
  C as BottleBeer
};
